<template>
  <b-form-input class="form-input" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
  export default {
    inheritAttrs: false,
  }
</script>

<style lang="scss" src="./FormInput.scss"></style>
